import { __assign, __generator } from "tslib";
import { call, put, select, takeEvery, all, takeLatest, take, race, fork, cancel, join, delay, } from 'redux-saga/effects';
import ddt from '@wix/da-ddt';
import { getIsLoggedIn, getCurrentUserId } from '../../publicSession/selectors';
import { restrictLoggedOut } from '../../redux/loggedout';
import { selectors, withOffset } from '../../Stream';
import { fetchCollections, initializeDeviation, initializeDeviationCollections, commitCollections, commitCollectionsFail, commitCollectionsSuccess, createCollection, createCollectionFail, createCollectionSuccess, undoChanges, toggleCollection, changeFave, collectFave, changeFaveSuccess, changeFaveFail, requestClose, setFaveState, resetJustFaved, } from './actionCreators';
import { getUpdatedEntities, getChangeDetails, getFeaturedId, getIsDeviationInitialized, getSelectedFolderIds, } from './selectors';
import { streamId, COLLECTIONS_PAGE_SIZE, UNDO_TIMEOUT } from './constants';
import { doFetchCollections, doFetchContainingCollectionIds, doCommitCollections, doCreateCollection, doFave, doUnfave, } from './xhr';
import { addNotificationToQueue } from '../../Notifications/redux/actionCreators';
import { NotificationType } from '../../Notifications/redux/types';
import { ModalType } from '../../Modals/redux/types';
import { pushModal, popModal } from '../../Modals/redux/actionCreators';
import { ReferralType } from '@wix/da-bi/pkg/constants';
var logger = ddt.createLogger('collections');
function handleFetchStream(action) {
    var actionStreamId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                actionStreamId = action.streamId;
                if (streamId !== actionStreamId) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, put(fetchCollections())];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function handleFetchCollections() {
    var _a, offset, limit, result, items_1, entities_1, errorMsg_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(function (state) { return ({
                    offset: withOffset.selectors.getNextOffset(state, streamId),
                    limit: selectors.getItemsPerFetch(state, streamId),
                }); })];
            case 1:
                _a = _b.sent(), offset = _a.offset, limit = _a.limit;
                _b.label = 2;
            case 2:
                _b.trys.push([2, 7, , 9]);
                return [4 /*yield*/, call(doFetchCollections, offset, limit)];
            case 3:
                result = _b.sent();
                if (!!result) return [3 /*break*/, 5];
                return [4 /*yield*/, put(withOffset.actions.fetchFailure({ streamId: streamId, errorMsg: 'fetch error' }))];
            case 4:
                _b.sent();
                return [2 /*return*/];
            case 5:
                items_1 = [];
                entities_1 = { collections: {} };
                result.results.forEach(function (collection) {
                    items_1.push(collection.folderId);
                    entities_1.collections[collection.folderId] = collection;
                });
                return [4 /*yield*/, put(withOffset.actions.fetchSuccessDeduped({
                        streamId: streamId,
                        items: items_1,
                        entities: entities_1,
                        hasMore: result.hasMore || false,
                    }))];
            case 6:
                _b.sent();
                return [3 /*break*/, 9];
            case 7:
                errorMsg_1 = _b.sent();
                return [4 /*yield*/, put(withOffset.actions.fetchFailure({ streamId: streamId, errorMsg: errorMsg_1 }))];
            case 8:
                _b.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function initializeUser() {
    var userId, streamParams;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getCurrentUserId)];
            case 1:
                userId = _a.sent();
                return [4 /*yield*/, select(selectors.getStreamParams, streamId)];
            case 2:
                streamParams = _a.sent();
                if (!(streamParams && streamParams.userId)) return [3 /*break*/, 4];
                if (streamParams.userId === userId) {
                    logger.log('User collections already init', streamParams);
                    return [2 /*return*/];
                }
                logger.log('Collection stream belongs to another user', streamParams);
                return [4 /*yield*/, put(withOffset.actions.deleteStream(streamId))];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4:
                logger.log('Initializing user collections');
                return [4 /*yield*/, put(withOffset.actions.initialize({
                        streamId: streamId,
                        itemsPerFetch: COLLECTIONS_PAGE_SIZE,
                        items: [],
                        hasMore: true,
                        streamParams: {
                            type: 'userCollections',
                            userId: userId,
                        },
                    }))];
            case 5:
                _a.sent();
                // do initial fetch
                return [4 /*yield*/, handleFetchCollections()];
            case 6:
                // do initial fetch
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function handleInitializeDeviation(action) {
    var isLoggedIn, _a, deviationId, faveCount, noPreselectedFeatured, ignorePreselectedCollections, isAlreadyInit, result, selected, featuredId;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!action.payload) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(getIsLoggedIn)];
            case 1:
                isLoggedIn = _b.sent();
                if (!!isLoggedIn) return [3 /*break*/, 3];
                return [4 /*yield*/, put(restrictLoggedOut({ restrictedActionName: ReferralType.FAVOURITE }))];
            case 2:
                _b.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, call(initializeUser)];
            case 4:
                _b.sent();
                _a = action.payload, deviationId = _a.deviationId, faveCount = _a.faveCount, noPreselectedFeatured = _a.noPreselectedFeatured, ignorePreselectedCollections = _a.ignorePreselectedCollections;
                logger.log('Initializing deviation', deviationId);
                return [4 /*yield*/, select(getIsDeviationInitialized, deviationId)];
            case 5:
                isAlreadyInit = _b.sent();
                if (!!isAlreadyInit) return [3 /*break*/, 8];
                logger.log('Fetching containing collections');
                return [4 /*yield*/, call(doFetchContainingCollectionIds, deviationId)];
            case 6:
                result = _b.sent();
                if (!result) return [3 /*break*/, 8];
                logger.log('Initializing deviation collections', deviationId, result);
                return [4 /*yield*/, put(initializeDeviationCollections(deviationId, result, faveCount, noPreselectedFeatured, ignorePreselectedCollections))];
            case 7:
                _b.sent();
                _b.label = 8;
            case 8: return [4 /*yield*/, select(getSelectedFolderIds, deviationId)];
            case 9:
                selected = _b.sent();
                if (!!selected.length) return [3 /*break*/, 12];
                if (noPreselectedFeatured) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(getFeaturedId)];
            case 10:
                featuredId = _b.sent();
                logger.log('Setting selection to default featured', featuredId);
                if (!featuredId) return [3 /*break*/, 12];
                return [4 /*yield*/, put(toggleCollection(featuredId, deviationId))];
            case 11:
                _b.sent();
                _b.label = 12;
            case 12: return [2 /*return*/];
        }
    });
}
function saveSelection(deviationId, selected) {
    var result, failedFolders, successFolders;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                logger.log('Saving selection', selected);
                return [4 /*yield*/, call(doCommitCollections, selected, deviationId)];
            case 1:
                result = _a.sent();
                failedFolders = result && result.failedFolders
                    ? result.failedFolders
                    : !result || !result.success
                        ? selected
                        : [];
                successFolders = selected.filter(function (folderId) { return !failedFolders.includes(folderId); });
                logger.log('Save complete', { failedFolders: failedFolders, successFolders: successFolders });
                return [2 /*return*/, { failedFolders: failedFolders, successFolders: successFolders }];
        }
    });
}
function handleCommitCollections(_a) {
    var isLoggedIn, _b, changeType, added, removed, selected, saved, wasFavourite, willBeFavourite, notification, saveProcess, undo, undoNotification, _c, failedFolders, successFolders, entities;
    var _d = _a.payload, deviationId = _d.deviation.deviationId, deviation = _d.deviation, notificationQueue = _d.notificationQueue;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0: return [4 /*yield*/, select(getIsLoggedIn)];
            case 1:
                isLoggedIn = _e.sent();
                if (!!isLoggedIn) return [3 /*break*/, 3];
                return [4 /*yield*/, put(restrictLoggedOut({ restrictedActionName: ReferralType.FAVOURITE }))];
            case 2:
                _e.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, select(getChangeDetails, deviationId)];
            case 4:
                _b = _e.sent(), changeType = _b.changeType, added = _b.added, removed = _b.removed, selected = _b.selected, saved = _b.saved, wasFavourite = _b.wasFavourite, willBeFavourite = _b.willBeFavourite;
                if (!(changeType === 'none')) return [3 /*break*/, 6];
                // nothing changed
                logger.log('No changes found, bailing commit', {
                    changeType: changeType,
                    added: added,
                    removed: removed,
                    selected: selected,
                    wasFavourite: wasFavourite,
                    willBeFavourite: willBeFavourite,
                });
                return [4 /*yield*/, put(commitCollectionsSuccess(saved, deviationId, {}))];
            case 5:
                _e.sent();
                return [2 /*return*/];
            case 6:
                notification = {
                    changeType: changeType,
                    changedFolderCount: added.length + removed.length,
                    exampleCollectionId: added[0] || removed[0],
                    collectedDeviation: deviation,
                };
                if (!(wasFavourite !== willBeFavourite)) return [3 /*break*/, 8];
                return [4 /*yield*/, put(setFaveState(deviation, willBeFavourite))];
            case 7:
                _e.sent();
                _e.label = 8;
            case 8: return [4 /*yield*/, put(addNotificationToQueue(notificationQueue, NotificationType.Collect, notification))];
            case 9:
                _e.sent();
                return [4 /*yield*/, fork(saveSelection, deviationId, selected)];
            case 10:
                saveProcess = _e.sent();
                return [4 /*yield*/, race({
                        undo: take(function (undoAction) {
                            return undoAction.type === undoChanges.toString() &&
                                undoAction.payload &&
                                undoAction.payload.deviationId === deviationId;
                        }),
                        wait: delay(UNDO_TIMEOUT),
                    })];
            case 11:
                undo = (_e.sent()).undo;
                if (!undo) return [3 /*break*/, 17];
                logger.log('Undo caught');
                undoNotification = __assign({}, notification);
                if (!(wasFavourite !== willBeFavourite)) return [3 /*break*/, 13];
                return [4 /*yield*/, put(setFaveState(deviation, wasFavourite))];
            case 12:
                _e.sent();
                _e.label = 13;
            case 13: return [4 /*yield*/, put(addNotificationToQueue(notificationQueue, NotificationType.CollectUndo, undoNotification))];
            case 14:
                _e.sent();
                // undoing - cancel previous save and start a new one with the original folders
                return [4 /*yield*/, cancel(saveProcess)];
            case 15:
                // undoing - cancel previous save and start a new one with the original folders
                _e.sent();
                return [4 /*yield*/, fork(saveSelection, deviationId, saved)];
            case 16:
                saveProcess = _e.sent();
                _e.label = 17;
            case 17: 
            // wait for the save to finish and process results
            return [4 /*yield*/, join(saveProcess)];
            case 18:
                // wait for the save to finish and process results
                _e.sent();
                _c = saveProcess.result(), failedFolders = _c.failedFolders, successFolders = _c.successFolders;
                logger.log('Storing results', { failedFolders: failedFolders, successFolders: successFolders });
                if (!failedFolders.length) return [3 /*break*/, 20];
                return [4 /*yield*/, put(commitCollectionsFail(failedFolders, deviationId))];
            case 19:
                _e.sent();
                _e.label = 20;
            case 20: return [4 /*yield*/, select(getUpdatedEntities, deviationId)];
            case 21:
                entities = _e.sent();
                return [4 /*yield*/, put(commitCollectionsSuccess(successFolders, deviationId, entities))];
            case 22:
                _e.sent();
                return [2 /*return*/];
        }
    });
}
function handleCreateCollection(action) {
    var isLoggedIn, _a, name, selectDeviationId, result;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!action.payload) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(getIsLoggedIn)];
            case 1:
                isLoggedIn = _c.sent();
                if (!!isLoggedIn) return [3 /*break*/, 3];
                return [4 /*yield*/, put(restrictLoggedOut({ restrictedActionName: ReferralType.FAVOURITE }))];
            case 2:
                _c.sent();
                return [2 /*return*/];
            case 3:
                _a = action.payload, name = _a.name, selectDeviationId = _a.selectDeviationId;
                return [4 /*yield*/, call(doCreateCollection, name)];
            case 4:
                result = _c.sent();
                if (!(!result || !result.success || !result.gallection)) return [3 /*break*/, 6];
                return [4 /*yield*/, put(createCollectionFail(name))];
            case 5:
                _c.sent();
                return [2 /*return*/];
            case 6: return [4 /*yield*/, all([
                    put(createCollectionSuccess(result.gallection.folderId, {
                        collections: (_b = {},
                            _b[result.gallection.folderId] = result.gallection,
                            _b),
                    })),
                    put(withOffset.actions.insertItems({
                        streamId: streamId,
                        items: [result.gallection.folderId],
                        offset: 1, // insert after featured, which is always first
                    })),
                    put(toggleCollection(result.gallection.folderId, selectDeviationId)),
                ])];
            case 7:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
function doChangeFave(_a) {
    var isLoggedIn, result, notification;
    var _b = _a.payload, deviation = _b.deviation, deviationId = _b.deviation.deviationId, to = _b.to, notificationQueue = _b.notificationQueue;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, select(getIsLoggedIn)];
            case 1:
                isLoggedIn = _c.sent();
                if (!!isLoggedIn) return [3 /*break*/, 3];
                return [4 /*yield*/, put(restrictLoggedOut({ restrictedActionName: ReferralType.FAVOURITE }))];
            case 2:
                _c.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, call(to ? doFave : doUnfave, deviationId)];
            case 4:
                result = _c.sent();
                notification = {
                    deviation: deviation,
                    success: result.success,
                };
                if (!!result.success) return [3 /*break*/, 6];
                return [4 /*yield*/, put(changeFaveFail(deviationId))];
            case 5:
                _c.sent();
                return [2 /*return*/];
            case 6: return [4 /*yield*/, all([
                    put(changeFaveSuccess(deviationId, to)),
                    put(addNotificationToQueue(notificationQueue, NotificationType.Fave, notification)),
                ])];
            case 7:
                _c.sent();
                return [4 /*yield*/, delay(10000)];
            case 8:
                _c.sent();
                return [4 /*yield*/, put(resetJustFaved(deviationId))];
            case 9:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
export function openCollectionModal(_a) {
    var isLoggedIn;
    var _b = _a.payload, deviation = _b.deviation, notificationQueue = _b.notificationQueue;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                // custom queues should handle it themselves
                if (notificationQueue !== 'default') {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(getIsLoggedIn)];
            case 1:
                isLoggedIn = _c.sent();
                if (!!isLoggedIn) return [3 /*break*/, 3];
                return [4 /*yield*/, put(restrictLoggedOut({ restrictedActionName: ReferralType.FAVOURITE }))];
            case 2:
                _c.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, put(pushModal(ModalType.COLLECTION_POPOVER, {
                    wrapInModal: false,
                    params: {
                        collectibleDeviation: deviation,
                        ignorePreselectedCollections: true,
                    },
                }))];
            case 4:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
function closeCollectionModal() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, put(popModal())];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(withOffset.actions.STREAM__WITH_OFFSET__FETCH, handleFetchStream),
                    takeLatest(fetchCollections, handleFetchCollections),
                    takeEvery(initializeDeviation, handleInitializeDeviation),
                    takeEvery(commitCollections, handleCommitCollections),
                    takeEvery(createCollection, handleCreateCollection),
                    takeLatest(changeFave, doChangeFave),
                    takeLatest(collectFave, openCollectionModal),
                    takeLatest(requestClose, closeCollectionModal),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map